// consola is only a transitive dep (via Nuxt/Nitro); run `npm install consola` if a dep bump removes it.
import { createConsola } from 'consola'
import { colors } from 'consola/utils'
import { getContext } from 'unctx'

export function useLogger(tag = 'fcpLocalDev') {
  // Reads Nitro's request context by key; importing useEvent from nitropack/runtime breaks the client bundle.
  const event = getContext('nitro-app').tryUse()?.event

  if ( event?.context?.logger ) {
    event.context.logger.info('Returning logger from useLogger')
    return event.context.logger
  }
  else {
    const log = createConsola({fancy: true, formatOptions: { colors: true }})
    return {
      info: (message) => tag ? log.withTag(tag).info(colors.cyan(message)) : log.info(colors.cyan(message)),
      error: (message) => tag ? log.withTag(tag).error(colors.red(message)) : log.error(colors.red(message)),
      log: (message) => tag ? log.withTag(tag).log(colors.green(message)) : log.log(colors.green(message)),
      warn: (message) => tag ? log.withTag(tag).warn(colors.yellow(message)) : log.warn(colors.yellow(message)),
      box: (message) => tag ? log.withTag(tag).box(colors.magenta(message)) : log.box(colors.magenta(message))
    }
  }
}